var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border baseContentFont mx-1 py-1 text-center"},[_vm._v("\n  "+_vm._s(_vm.customMsg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }